import { render, staticRenderFns } from "./fa.vue?vue&type=template&id=2cd66a58&scoped=true"
import script from "./fa.vue?vue&type=script&lang=js"
export * from "./fa.vue?vue&type=script&lang=js"
import style0 from "./fa.vue?vue&type=style&index=0&id=2cd66a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd66a58",
  null
  
)

export default component.exports